module.exports = __webpack_public_path__ + "img/banner2_cn.3ed97b9c.png";